var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 7.33333H5.21979L8.47312 4.08C8.73312 3.82 8.73312 3.39333 8.47312 3.13333C8.41144 3.07153 8.33819 3.0225 8.25754 2.98904C8.17689 2.95559 8.09043 2.93837 8.00312 2.93837C7.91581 2.93837 7.82935 2.95559 7.7487 2.98904C7.66806 3.0225 7.5948 3.07153 7.53312 3.13333L3.13979 7.52667C3.07798 7.58834 3.02895 7.6616 2.9955 7.74225C2.96204 7.8229 2.94482 7.90935 2.94482 7.99667C2.94482 8.08398 2.96204 8.17043 2.9955 8.25108C3.02895 8.33173 3.07798 8.40499 3.13979 8.46667L7.53312 12.86C7.59484 12.9217 7.66812 12.9707 7.74876 13.0041C7.8294 13.0375 7.91583 13.0547 8.00312 13.0547C8.09041 13.0547 8.17684 13.0375 8.25748 13.0041C8.33813 12.9707 8.4114 12.9217 8.47312 12.86C8.53484 12.7983 8.5838 12.725 8.6172 12.6444C8.65061 12.5637 8.6678 12.4773 8.6678 12.39C8.6678 12.3027 8.65061 12.2163 8.6172 12.1356C8.5838 12.055 8.53484 11.9817 8.47312 11.92L5.21979 8.66667H12.6665C13.0331 8.66667 13.3331 8.36667 13.3331 8C13.3331 7.63333 13.0331 7.33333 12.6665 7.33333Z",
    fill: "#D2D3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/backArrow.70a874607cb39b551e4d4e186829a6d7.svg";
export { ForwardRef as ReactComponent };